import {Component, Inject, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import {
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
  MsalService,
  MsalBroadcastService,
} from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest,
  PopupRequest,
  AuthenticationResult,
  InteractionType,
} from '@azure/msal-browser';
import {LoginService} from '../../services/login.service';
import {Router} from '@angular/router';
import {UserProfileService} from '../../services/user-profile.service';
import {filter, takeUntil} from 'rxjs';

@Component({
  selector: 'user-avatar',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './user-avatar.html',
  styleUrl: './user-avatar.scss'
})
export class UserAvatar {

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private loginService: LoginService,
    private router: Router,
    private userService: UserProfileService
  ) {
  }

  ngOnInit(): void {

    this.authService
      .handleRedirectObservable()
      .subscribe((result: AuthenticationResult) => {
        if (result) {
          const redirectStartPage = localStorage.getItem('redirectStartPage'); // Retrieve the URL from local storage
          if (redirectStartPage) {
            this.router.navigate([redirectStartPage]);
            localStorage.removeItem('redirectStartPage'); // Clear the URL from local storage
          }
        }
      });
  }


  editProfile() {
    this.router.navigate(['/profile']);
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
}
